import Request from './request';
import consts from "@/consts.js";

async function fetch(data) {
    if (data && data.itemsPerPage == -1) {
        data.itemsPerPage = consts.limitAll; // 获取全部
        // data.limit = consts.limitAll; // 获取全部
    }
    // data.limit = consts.limitAll; // 获取全部
    // return Request('get', "api/order-rulers", data);
    if (data.type == 1) {//最少订货规则
        return Request('get', "api/order-rulers/min-quantity", data);
    } else if (data.type == 2) {//数量匹配规则
        return Request('get', "api/order-rulers/quantity", data);
    } else if (data.type == 3) {//最大订货规则
        return Request('get', "api/order-rulers/max-quantity", data);        
    } else if (data.type == 4) {//最小订货金额规则
        return Request('get', "api/order-rulers/min-amount", data);        
    } else if (data.type == 5) {//自动标配规则
        return Request('get', "api/order-rulers/auto", data);        
    }  else if (data.type == 6) {//组合商品规则
        return Request('get', "api/order-rulers/combine-material", data);        
    }    else if (data.type == 7) {//运费计算规则
        return Request('get', "api/order-rulers/express-fee", data);        
    }   else if (data.type == 9) {//强制订货规则
        return Request('get', "api/order-rulers/force-order", data);        
    }   
}

async function fetchOne(id, data) {
    // return Request('get', "api/order-rulers/" + id, data);
    if (data.type == 1) {//最少订货规则
        return Request('get', "api/order-rulers/min-quantity-view/" + id);
    } else if (data.type == 2) {//数量匹配规则
        return Request('get', "api/order-rulers/quantity-view/"+ id);
    } else if (data.type == 3) {//最大订货规则
        return Request('get', "api/order-rulers/max-quantity-view/"+ id);        
    } else if (data.type == 4) {//最小订货金额规则
        return Request('get', "api/order-rulers/min-amount-view/"+ id);        
    } else if (data.type == 5) {//自动标配规则
        return Request('get', "api/order-rulers/auto-view/"+ id);        
    }  else if (data.type == 6) {//组合商品规则
        return Request('get', "api/order-rulers/combine-material-view/"+ id);        
    }    else if (data.type == 7) {//运费计算规则
        return Request('get', "api/order-rulers/express-fee-view/"+ id);        
    }  else if (data.type == 9) {//强制订货规则
        return Request('get', "api/order-rulers/force-order-view/"+ id);        
    }    
}

async function save(type, data) {
    if (type == 1) {//最少订货规则
        return Request('post', "api/order-rulers/save-min-quantity", data);
    } else if (type == 2) {//数量匹配规则
        return Request('post', "api/order-rulers/save-quantity", data);
    } else if (type == 3) {//最大订货规则
        return Request('post', "api/order-rulers/save-max-quantity", data);        
    } else if (type == 4) {//最小订货金额规则
        return Request('post', "api/order-rulers/save-min-amount", data);        
    } else if (type == 5) {//自动标配规则
        return Request('post', "api/order-rulers/save-auto", data);        
    }  else if (type == 6) {//组合商品规则
        return Request('post', "api/order-rulers/save-combine-material", data);        
    }    else if (type == 7) {//运费计算规则
        return Request('post', "api/order-rulers/save-express-fee", data);        
    }  else if (type == 9) {//强制订货规则
        return Request('post', "api/order-rulers/save-force-order", data);        
    }    
}



async function changeStatus(id) {// 改变启用状态
    return Request('delete', "api/order-rulers/update-status/" + id);
}

async function del(id, data) {// 删除数据
    // return Request('delete', "api/order-rulers/delete/" + id);
    if (data.type == 1) {//最少订货规则
        return Request('delete', "api/order-rulers/min-quantity-delete/" + id);
    } else if (data.type == 2) {//数量匹配规则
        return Request('delete', "api/order-rulers/quantity-delete/"+ id);
    } else if (data.type == 3) {//最大订货规则
        return Request('delete', "api/order-rulers/max-quantity-delete/"+ id);        
    } else if (data.type == 4) {//最小订货金额规则
        return Request('delete', "api/order-rulers/min-amount-delete/"+ id);        
    } else if (data.type == 5) {//自动标配规则
        return Request('delete', "api/order-rulers/auto-delete/"+ id);        
    }  else if (data.type == 6) {//组合商品规则
        return Request('delete', "api/order-rulers/combine-material-delete/"+ id);        
    }    else if (data.type == 7) {//运费计算规则
        return Request('delete', "api/order-rulers/express-fee-delete/"+ id);        
    }   else if (data.type == 9) {//强制订货规则
        return Request('delete', "api/order-rulers/force-order-delete/"+ id);        
    }    
}

export default {
    fetch,
    fetchOne,
    save,
    changeStatus,
    del,
};